import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { Typography } from "@mui/material";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/unsure.png",
  title: "Buscar melhores soluções",
  buttonText: "Iniciar cadastro de imóvel",
  nextScreen: "/onboarding/building-type",
};

export const Diagnosis = ({ history }) => {
  const handleClick = () => {
    history.push(FRAME_DATA.nextScreen);
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
      <BlockStandard hideDivider>
        <Typography variant="h3">
          A iniciativa de buscar soluções para reduzir custos com energia e
          descarbonizar vai começar agora!
        </Typography>
        <Typography variant="h3">
          Estamos aqui para te apoiar simplificando essa jornada!
        </Typography>
        <Typography variant="h3">
          Para indicarmos as melhores soluções, precisamos conhecer o imóvel
          para o qual você está buscando soluções.
        </Typography>
      </BlockStandard>
    </SolutionsFrame>
  );
};
